<form [formGroup]="userDetailsForm">
  <p class="subtitle has-text-info mb-4">{{ 'register.info' | translate }}</p>
  <hr>

    <div class="mb-4">
      <p class="mb-2">{{ 'register.email' | translate }}</p>
      <input [ngClass]="{'is-danger': userDetailsForm.get('email')?.invalid && userDetailsForm.get('email')?.touched}"
        formControlName="email"
        class="input"
        type="text"
        placeholder="{{ 'register.email' | translate }}">
    </div>
    @if (userDetailsForm.contains('emailConfirmation')) {
      <div class="mb-4">
        <p class="mb-2">{{ 'register.email-confirmation' | translate }}</p>
        <input [ngClass]="{'is-danger': userDetailsForm.get('emailConfirmation')?.invalid && userDetailsForm.get('emailConfirmation')?.touched}"
          formControlName="emailConfirmation"
          class="input mb-2"
          type="text"
          placeholder="{{ 'register.email-confirmation' | translate }}">
        @if (userDetailsForm.hasError('not-equal')) {
          <p class="help is-danger">{{ 'register.confirm-failed' | translate }}</p>
        }
      </div>
    }
    <button class="button is-primary is-fullwidth mb-4" (click)="submit()" [disabled]="userDetailsForm.invalid">{{ 'register.validate' | translate }}</button>
  </form>
